<template>
	<div class="gallery-input">
		<div
			class="gallery-input__wrap"
			@mouseover="showTooltip"
			@mouseleave="hideTooltip"
		>
			<SvgIcon class="gallery-input__wrap-placeholder-big" iconName="ico-img-big"/>
			<input
				class="gallery-input__wrap-input"
				multiple
				type="file"
				accept=".jpg, .jpeg, .png"
				ref="fileInput"
				id="galleryInputId"
				@click="onFileClick"
				@change="onFileChange"
				@dragover="dragover"
			>
			<a class="btn btn--icon btn--add_image-button" id="add_image-button" @click="trigger">
				<SvgIcon class="gallery-input__wrap-icon-plus" iconName="ico-plus"/>
				<span>Add Image</span>
			</a>
			<div class="gallery-input__main-image" v-for="image in images.slice(0, 1)" :key="image">
				<img class="gallery-input-img" alt="" :src="image" />
			</div>
			<span class="upload-image__tooltip" ref="tooltipFormat">{{ message }}
				<span class="arrow-angle"></span>
			</span>
			<div class="notification-upload">
				<PartNotifications ref="SupportedFormat" v-if="showError" :data="DataSupportedFormat"/>
			</div>
		</div>

		<div v-if="images" class="gallery-input__wrap-box-img">
			<div class="gallery-input__wrap-img" v-for="(image, index) in images.slice(0, 7)" :key="image">
				<img class="gallery-input-img" :src="image" alt=""/>
				<a class="gallery-input__wrap-img-remove" @click="removeImage(index)">
					<SvgIcon class="gallery-input__wrap-icon" iconName="ico-close-sm"/>
				</a>
				<div class="gallery-input__wrap-img-box-main">
					<a class="btn btn--xs gallery-input__wrap-img-main" :id="`main_img-${index}-button`" @click="setMainImg(index)">Main Image</a>
				</div>
			</div>
			<div class="gallery-input__placeholder-wrap" v-for="(item, index) in items" :key="index">
				<SvgIcon class="gallery-input__placeholder-icon" iconName="ico-img"/>
			</div>
		</div>
		<div class="gallery-input__error-message" ref="error">
			<span>A maximum of 7 images can be added!</span>
		</div>
		<div class="gallery-input__error-message" ref="errorSameImg">
			<span>This image has already been added!</span>
		</div>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartNotifications from '@/components/parts/PartNotifications';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	components: {
		SvgIcon,
		PartNotifications
	},
	data () {
		return {
			images: [],
			deleted_images: [],
			new_images: [],
			main_image: [],
			mainHelper: [],
			delete_main_image: false,
			items: ['', '', '', '', '', '', ''],
			ImageNum: false,
			remove: false,
			chooseMain: false,
			classError: 'gallery-input__error-message--show',
			AddedImg: 'hide-btn',
			isLoaded: false,
			showError: false,
			message: 'Supported image formats: jpg, jpeg, png!',
			DataSupportedFormat: {
				type: 'danger',
				msg: 'Only jpg/jpeg and png files are allowed!'
			},
			isFormatAccepted: false
		};
	},
	watch: {
		images() {
			this.$emit('uploadImages', this.new_images);

			if (this.images.length) {
				if (this.images[0].includes('base64')) {
					this.main_image = [this.images[0]];
				} else {
					const img = this.images[0].split('/').pop();
					const folder = this.images[0].substring(0, this.images[0].lastIndexOf('/')).split('/').pop();
					this.main_image = [`${folder}/${img}`];
				}
			}

			this.$emit('setMainImage', this.main_image);

			if (this.images.length > 0) {
				this.$refs.fileInput.parentNode.classList.add(this.AddedImg);
			}

			if (this.images.length > 0 && !this.remove && !this.chooseMain) {
				if (!this.isLoaded) {
					for (let i = 0; i < this.images.length; i++) {
						this.items.shift();
					}
				} else {
					this.items.shift();
				}

				this.isLoaded = true;
			}

			if (this.images.length <= 0) {
				this.$refs.fileInput.parentNode.classList.remove(this.AddedImg);
			}
		},
		deleted_images() {
			this.$emit('deletedImages', this.deleted_images);
		}
	},
	methods: {
		showTooltip() {
			this.$refs.tooltipFormat.classList.add('showTooltip');
		},
		hideTooltip() {
			this.$refs.tooltipFormat.classList.remove('showTooltip');
		},
		dragover(event) {
			event.preventDefault();
			this.$refs.tooltipFormat.classList.remove('showTooltip');
		},
		onFileClick(event) {
			event.target.value = '';
		},
		drop(event) {
			event.preventDefault();
			this.$refs.fileInput.images = event.dataTransfer.images;
			this.onChange();
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			this.createImage(files);
			this.$refs.tooltipFormat.classList.remove('showTooltip');
			if (files.length > 7) {
				this.$refs.error.classList.add(this.classError);
				setTimeout(() => {
					this.$refs.error.classList.remove(this.classError);
				}, 2000);
			}
			this.$refs.fileInput.parentNode.classList.add(this.AddedImg);

			const fileName = document.getElementById('galleryInputId').value;
			const idxDot = fileName.lastIndexOf('.') + 1;
			const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
			if (!(extFile === 'jpg' || extFile === 'jpeg' || extFile === 'png')) {
				this.showError = true;
				this.isFormatAccepted = true;
				this.$refs.tooltipFormat.classList.remove('showTooltip');

				setTimeout(() => {
					this.showError = false;
				}, 2000);
			}
		},
		resizeImage(base64Str, maxWidth = 400, maxHeight = 350) {
			if (this.byteCount(base64Str) < 5000000) {
				return new Promise((resolve) => {
					resolve(base64Str);
				});
			}
			return new Promise((resolve) => {
				const img = new Image();
				img.src = base64Str;
				img.onload = () => {
					const canvas = document.createElement('canvas');
					const MAX_WIDTH = maxWidth;
					const MAX_HEIGHT = maxHeight;
					let width = img.width;
					let height = img.height;

					if (width > height) {
						if (width > MAX_WIDTH) {
							height *= MAX_WIDTH / width;
							width = MAX_WIDTH;
						}
					} else {
						if (height > MAX_HEIGHT) {
							width *= MAX_HEIGHT / height;
							height = MAX_HEIGHT;
						}
					}
					canvas.width = width;
					canvas.height = height;
					const ctx = canvas.getContext('2d');
					ctx.drawImage(img, 0, 0, width, height);
					resolve(canvas.toDataURL());
				};
			});
		},
		byteCount(string) {
			return (encodeURI(string).split(/%..|./).length - 1) / 1.37;
		},
		createImage(files) {
			const fileName = document.getElementById('galleryInputId').value;
			const idxDot = fileName.lastIndexOf('.') + 1;
			const extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
			if ((extFile === 'jpg' || extFile === 'jpeg' || extFile === 'png')) {
				this.remove = false;
				this.chooseMain = false;
				const vm = this;

				let count = 0;
				if (this.images.length > 0) {
					const newCount = this.images.length + files.length;
					if (newCount > 7) {
						count = 7 - this.images.length;
					} else {
						count = files.length;
					}
				} else {
					count = files.length > 7 ? 7 : files.length;
				}

				for (let index = 0; index < count; index++) {
					const reader = new FileReader();
					reader.onload = async function(event) {
						let imageUrl = event.target.result;
						if (vm.images.length < 7) {
							if (imageUrl.includes('base64')) {
								await vm.resizeImage(imageUrl).then(function(image) {
									imageUrl = image;
									if (!vm.images.includes(imageUrl)) {
										vm.images.push(imageUrl);
										vm.new_images.push(imageUrl);
									} else {
										vm.$refs.errorSameImg.classList.add(vm.classError);
										setTimeout(() => {
											vm.$refs.errorSameImg.classList.remove(vm.classError);
										}, 2000);
									}
								});
							} else {
								vm.images.push(imageUrl);
								vm.new_images.push(imageUrl);
							}
						}
					};
					reader.readAsDataURL(files[index]);
				}
			}
			if (this.images.length >= 7) {
				this.$refs.error.classList.add(this.classError);
				setTimeout(() => {
					this.$refs.error.classList.remove(this.classError);
				}, 2000);
			}
		},
		removeImage(index) {
			this.images.forEach((el, i) => {
				if (el.includes('http') && index === i) {
					const img = el.split('/').pop();
					const folder = el.substring(0, el.lastIndexOf('/')).split('/').pop();
					this.deleted_images.push(`${folder}/${img}`);
				}
			});

			this.remove = true;
			this.chooseMain = false;

			this.images.splice(index, 1);
			this.new_images.splice(index, 1);

			// Add placeholder
			if (this.items.length < 7 && this.remove) {
				this.items.push('');
			}

			if (index === 0) {
				if (this.images.length) {
					this.main_image = [this.images[0]];
				} else {
					this.main_image = [];
				}
				this.delete_main_image = true;
				this.$emit('deleteMainImage', this.delete_main_image);
			}
		},
		trigger () {
			this.$refs.fileInput.click();
		},
		setMainImg(index) {
			this.chooseMain = true;
			let mainImg = this.images[index];
			this.images.splice(index, 1);
			this.images.unshift(mainImg);
			this.resizeImage(mainImg).then(function(image) {
				mainImg = image;
			});
		},
		setValue(value) {
			this.images = value;
		},
		resetValue() {
			this.images = [];
		}
	}
};
</script>

<style lang="scss" scoped>
.upload-image__tooltip {
	position: absolute;
	bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    font-size: 12px;
	background-color: $grey-light;
	border-radius: 8px;
	padding: 5px 10px;
	opacity: 0;
	visibility: hidden;
	transition: all 0.75s ease;
	font-family: $font-main;
	line-height: 1.2;
	text-align: center;
	max-width: 150px;
	color: $fiord;
	pointer-events: none;

	@include mq($xl) {
		opacity: 1;
		visibility: visible;
		max-width: fit-content;
		bottom: 5px;
		padding: 5px 10px;
	}

	&.showTooltip {
		opacity: 1;
		visibility: visible;
	}
}

.arrow-angle {
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 10px 10px 10px;
	border-color: transparent transparent #ebecf0 transparent;
	top: -10px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

	@include mq($xl) {
		display: none;
	}
}

.notification-upload {
	z-index: 8;
    position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: fit-content;

	@include mq($sm) {
		max-width: 90%;
	}
}

.hide-btn {
	.btn--icon {
		opacity: 0;
		transition: $dur $ease;

		@include mq($xl) {
			opacity: 1;
		}
	}

	@include hover {
		.gallery-input__main-image {
			img {
				-webkit-filter: blur(2px); /* Chrome, Safari, Opera */
				filter: blur(2px);
			}
		}

		.btn--icon {
			opacity: 1;
		}
	}
}

.gallery-input__error-message {
	position: absolute;
    top: 150px;
    transform: translateX(-50%);
    left: 50%;
    z-index: 10;
    background: #FFE1E1;
	border: 1px solid #F50404;
	opacity: 0;
	pointer-events: none;
	transition: $dur $ease;
	width: 100%;
    text-align: center;
	padding: 2px 26px;
	box-sizing: border-box;
    border-radius: 8px;
	max-width: fit-content;
	display: flex;
	align-items: center;
	justify-content: center;

	@include mq($sm) {
		align-items: flex-start;
		width: 90%;
		top: 100px;
	}

	span {
		font-family: $font-main;
		font-weight: 500;
		color: $red;
		font-size: 16px;
		line-height: 24px;

		@include mq(1600px) {
			font-size: 14px;
		}

		@include mq($lg) {
			line-height: 1.3;
		}
	}
}

.gallery-input__error-message--show  {
	opacity: 1;
}

.gallery-input__wrap-img-box-main {
	margin-top: 5px;
}

.gallery-input__wrap-img-main {
	position: absolute;
    left: 50%;
    transform: translateX(-50%);
	transition: $dur $ease;
	opacity: 0;
	height: 0;

	@include mq($xl) {
		opacity: 1;
		height: auto;
		position: relative;
		left: auto;
		transform: none;
	}
}

.gallery-input {
	position: relative;
}

.gallery-input__wrap-icon-plus {
	font-size: 12px;
    margin-right: 10px;
    display: inline-block;
}

.gallery-input__main-image {
	background-color: transparent;
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	border: none;
	pointer-events: none;

	img {
		transition: $dur $ease;
		object-fit: contain;
	}
}

.gallery-input__wrap {
	border: 2px dashed $slate-gray;
	box-sizing: border-box;
	border-radius: 8px;
	display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
	max-width: 757px;
	min-width: 100%;
	min-height: 349px;
	height: 100%;
	width: 100%;
	position: relative;
	margin-bottom: 20px;

	@include mq($lg) {
		max-width: 100%;
		min-height: 300px;
	}

	@include mq($sm) {
		min-height: 250px;
		max-height: 250px;
	}
}

.gallery-input__wrap-input {
	opacity: 0;
	cursor: pointer;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	height: 100%;
	width: 100%;
}

.gallery-input__wrap-placeholder-big {
	font-size: 108px;
	color: $grey-light;
	margin-bottom: 24px;

	@include mq($sm) {
		margin-bottom: 0;
	}
}

.gallery-input__wrap-box-img {
	display: flex;
	margin-top: auto;
	justify-content: space-between;

	@include mq(1670px) {
		margin-top: 40px;
	}

	@include mq(1450px) {
		margin-top: 50px;
	}

	@include mq($lg) {
		margin-top: 0;
	}

	@include mq(670px) {
		flex-wrap: wrap;
		justify-content: flex-start;
	}
}

.gallery-input__wrap-img {
	img {
		width: 100%;
		height: 100%;
		object-fit: contain;

		@include mq($xl) {
			min-height: 100%;
		}
	}

	@include mq($xl) {
		display: flex;
		flex-direction: column;
	}

	&:first-of-type {
		border: 2px solid $dodger-blue;

		&::after {
			content: 'Main Image';
			font-size: 12px;
			font-family: $font-main;
			padding: 2px 0;
			color: $fiord;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;

			@include mq(1900px) {
				font-size: 11px;
			}

			@include mq(1600px) {
				font-size: 10px;
			}
		}
		.gallery-input__wrap-img-main {
			display: none;
		}
	}

	&:not(:last-of-type) {
		margin-right: 23px;

		@include mq(1800px) {
			margin-right: 20px;
		}

		@include mq(1750px) {
			margin-right: 15px;
		}

		@include mq(1450px) {
			margin-right: 10px;
		}
	}

	@include hover {
		&:not(:first-of-type) {
			.gallery-input__wrap-img-main {
				height: auto;
				opacity: 1;
			}
		}
	}
}

.gallery-input__wrap-placeholder-sm {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 32px;
	color: $grey-light;

	svg {
		height: 32px;
	}
}

.gallery-input-img {
	height: 100%;
	width: 100%;
}

.gallery-input__wrap-img-remove {
	position: absolute;
	right: -15px;
    top: -15px;
	border: none;
	background-color: transparent;
	transition: $dur $ease;
	z-index: 1;

	&:focus {
		outline: none;
	}

	@include hover {
		color: $dodger-blue;
	}
}

.gallery-input__wrap-icon {
	background-color: $fiord;
    border-radius: 50%;
    padding: 5px;
	font-size: 10px;
	color: $white;

	svg {
		height: 15px;
	}
}

.gallery-input__placeholder-wrap {
	&:not(:last-of-type) {
		margin-right: 23px;

		@include mq(1800px) {
			margin-right: 20px;
		}

		@include mq(1750px) {
			margin-right: 15px;
		}

		@include mq(1450px) {
			margin-right: 10px;
		}
	}
}

.gallery-input__placeholder-icon {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-size: 32px;
	color: $grey-light;

	@include mq($sm) {
		font-size: 20px;
	}

	svg {
		height: 32px;

		@include mq($sm) {
			height: 20px;
		}
	}
}

.gallery-input__placeholder-wrap,
.gallery-input__wrap-img {
	position: relative;
	border: 2px dashed $slate-gray;
	box-sizing: border-box;
	border-radius: 8px;
	height: 90px;
	flex: 0 0 11%;
	display: block;
	min-width: 88px;
	width: 100%;

	@include mq(1900px) {
		min-width: 80px;
	}

	@include mq(1670px) {
		height: 70px;
		min-width: 60px;
	}

	@include mq(1450px) {
		height: 60px;
	}

	@include mq(1310px) {
		min-width: 12.3%;
	}

	@include mq($lg) {
		height: 90px;
		min-width: 88px;
	}

	@include mq($md) {
		height: 70px;
		min-width: 80px;
	}

	@include mq(670px) {
		height: 70px;
		min-width: 17%;
		display: flex;
		margin: 0 0 40px;
	}

	@include mq(400px) {
		height: 60px;
		min-width: 21%;
	}

	&:last-of-type {
		margin-right: 0;
	}
}

.btn--add_image-button {
	@include mq($sm) {
		margin-bottom: 10px;
	}
}
</style>
